import './css/contact-group.css';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faPlus,
  faTimes
} from '@fortawesome/free-solid-svg-icons';


import React from 'react';

class ContactEdit extends React.Component
{
  constructor(props)
  {
    super(props);
    if (!props.contact) { throw 'Must define contact'; }
    this.state = props.contact || {};
  }

  setv(key, value)
  {
    let o = {};
    o[key] = value;
    this.props.contact[key] = value;
    this.setState(o);
  }

  setContactType(type)
  {
    this.props.contact.c_type = type;
    if ([3, 20].indexOf()<0)
      this.props.contact.c_addr = null;
    else
      this.props.contact.c_num = '';
    this.forceUpdate();
  }

  getNumType()
  {
    switch (this.props.contact.c_type)
    {
      case  1: return 'tel';
      case  2: return 'email';
      case  3: return 'text';
      case 10: return 'tel';
      case 11: return 'tel';
      case 12: return 'tel';
      case 13: return 'email';
      case 20: return 'text';
      default: return 'text';
    }
  }
  getPlaceholder()
  {
    switch (this.props.contact.c_type)
    {
      case  1: return '電話號碼';
      case  2: return '電郵地址';
      case  3: return '地址';
      case 10: return '電話號碼';
      case 11: return '手機號碼';
      case 12: return '傳真號碼';
      case 13: return '電郵地址';
      case 20: return '地址';
      default: return '';
    }
  }

  render()
  {
    let contact = this.state;
    return (
      <div className="contact-edit">
        <select className="contact-type" value={contact.c_type} onChange={e=>this.setContactType(parseInt(e.target.value, 10))}>
          <option value={ 1}>賬單WhatsApp</option>
          <option value={ 4}>賬單Fax</option>
          <option value={ 2}>賬單電郵</option>
          <option value={ 3}>寄單地址</option>
          <option value={10}>電話</option>
          <option value={11}>手機</option>
          <option value={12}>傳真</option>
          <option value={13}>電郵</option>
          <option value={20}>地址</option>
        </select>
        { [3,20].indexOf(contact.c_type)<0
          ?<input className="contact-num" type={this.getNumType()} value={contact.c_num}
               placeholder={this.getPlaceholder()} onChange={e=> { this.setv('c_num', e.target.value.trim().toLowerCase())}}
           />
          :<input className="contact-addr" type="text" value={contact.c_addr}
               placeholder={this.getPlaceholder()} onChange={e=> { this.setv('c_addr', e.target.value.trim().toLowerCase())}}
           />
        }
        <input className="contact-name" type="text" value={contact.c_name} placeholder="聯絡人名稱"
               onChange={e=>this.setv('c_name', e.target.value.trimStart())}/>
        <select className="contact-sal" value={contact.c_sal} onChange={e=>this.setv('c_sal', e.target.value)}>
          <option value=""></option>
          <option value="先生">先生</option>
          <option value="小姐">小姐</option>
          <option value="太太">太太</option>
          <option value="秘書">秘書</option>
          <option value="博士">博士</option>
          <option value="教授">教授</option>
          <option value="醫生">醫生</option>
        </select>
        { this.props.button }
      </div>
    );
  }

}

class ContactGroupEditor extends React.Component
{
  constructor(props)
  {
    super(props);
    if (!props.contacts) { throw "Must define list of contacts"; }
    if (props.contacts.length < 1) this.addContact();
  }

  componentDidMount() { this._mounted = true; }
  forceUpdate() { if (this._mounted) super.forceUpdate(); }

  addContact()
  {
    this.props.contacts.push(
      {uid: -1, c_type: 1, c_name:'', c_sal:'', c_num:'', c_addr: null}
    );
    this.forceUpdate();
  }
  removeContact(index)
  {
    this.props.contacts.splice(index,1);
    this.forceUpdate();
  }

  createAddButton()
  {
    return (
      <button type="button" className="btn green tiny"
              onClick={e=>this.addContact()}>
        <FontAwesomeIcon icon={faPlus} />
      </button>
    );
  }
  createRemoveButton(i)
  {
    return (
      <button type="button" className="btn red tiny"
              onClick={e=>this.removeContact(i)}>
        <FontAwesomeIcon icon={faTimes} />
      </button>
    );
  }

  render()
  {
    return (
    <div className="contact-group-edit">
      { this.props.contacts.map( (c, i) =>
        i>0?<ContactEdit key={`cge-${c.uid}-${c.c_num}:${i}`} contact={c} button={this.createRemoveButton(i)}/>
           :<ContactEdit key={`cge-${c.uid}-${c.c_num}:${i}`} contact={c} button={this.createAddButton()}/>
      ) }
    </div>);
  }

}

export default ContactGroupEditor;